module.exports={key:"bbhospitality.symbo.ls"};